import { render, staticRenderFns } from "./stripe-payment-status.vue?vue&type=template&id=06c67973&scoped=true"
import script from "./stripe-payment-status.vue?vue&type=script&lang=js"
export * from "./stripe-payment-status.vue?vue&type=script&lang=js"
import style0 from "./stripe-payment-status.vue?vue&type=style&index=0&id=06c67973&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c67973",
  null
  
)

export default component.exports